module.exports = __webpack_public_path__ + "img/prize2.92c1edd5.png";